import { IGpsItemsForList } from '@nkr/models/index';
import { FormEvent, useState } from 'react';
import { Alert, Button, Col, ControlLabel, FormControl, FormGroup, Modal, Row } from 'react-bootstrap';
import { GpsTrackingNumberType } from '../gps-tracking-number-type';

interface IProps {
    show: boolean,
    data: IGpsItemsForList,
    trackingType: GpsTrackingNumberType,
    onFieldChange: (e: FormEvent<FormControl & HTMLInputElement>) => void,
    onConfirm: (trackingType: GpsTrackingNumberType) => void,
    onCancel: () => void
}

const AddTrackingNumber = (props: IProps) => {
    const [validTrackingNumber, setValidTrackingNumber] = useState(true);

    const handleConfirm = () => {
        let isValid = (props.trackingType == GpsTrackingNumberType.OutboundTrackingNumber ? props.data.outboundTrackingNumber : props.data.returnTrackingNumber) != '';

        setValidTrackingNumber(isValid);

        if (isValid) {
            props.onConfirm(props.trackingType);
        }
    };

    const handleCancel = () => {
        setValidTrackingNumber(true);
        props.onCancel();
    };

    const swapNumber = props.data != null ? props.data.swapNumber : '';
    const trackingNumber = props.data != null ? props.trackingType == GpsTrackingNumberType.OutboundTrackingNumber ? props.data.outboundTrackingNumber : props.data.returnTrackingNumber : '';
    const gpsNumber = props.data != null ? props.data.gpsNumber : '';
    const vendor = props.data != null ? props.data.vendor : '';
    const trackingLabel = props.trackingType == GpsTrackingNumberType.OutboundTrackingNumber ? "Outbound" : "Return";

    return (
        <Modal backdrop='static' show={props.show} onHide={handleCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Enter {trackingLabel} Tracking Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {!validTrackingNumber && (
                    <Alert bsStyle='danger' style={{ padding: '7.5px 15px' }}>
                        **All Fields Required** &nbsp;&nbsp;
                        Please correct the issues below...
                    </Alert>
                )}

                <Alert bsStyle='info' style={{ paddingTop: 7.5, paddingBottom: 7.5 }}>
                    <Row>
                        <Col xs={12} lg={1}>Swap:</Col>
                        <Col xs={12} lg={10}>{swapNumber}</Col>
                    </Row>
                    <Row>
                        <Col xs={12} lg={1}>GPS:</Col>
                        <Col xs={12} lg={10}>{gpsNumber} ({vendor})</Col>
                    </Row>
                </Alert>

                <FormGroup validationState={validTrackingNumber ? null : 'error'}>
                    <ControlLabel>Enter the {trackingLabel} Tracking Number</ControlLabel>
                    <FormControl
                        id='gpsLink'
                        style={{ width: '100%' }}
                        placeholder='Enter tracking number'
                        value={trackingNumber}
                        onChange={props.onFieldChange}
                    />
                </FormGroup>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={handleConfirm}>{trackingNumber.length > 0 ? 'Update' : 'Add'} Tracking Number</Button>
                <Button onClick={handleCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default AddTrackingNumber;